// Api.js

const apiKey = process.env.REACT_APP_GEN_API_KEY; // Initialize with your API key
const SERVER_URL = "https://api.heygen.com"; // Initialize with your server URL

async function newSession(quality, avatar_name, voice_id) {
  const response = await fetch(`${SERVER_URL}/v2/realtime/new`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Api-Key": apiKey,
    },
    body: JSON.stringify({
      quality: "high",
    }),
  });
  console.log("response", quality, avatar_name, voice_id, response.status);
  if (response.status === 500) {
    console.error("Server error");

    throw new Error("Server error");
  } else {
    const data = await response.json();
    console.log(data.data);
    return data.data;
  }
}

// start the session
async function startSession(session_id, sdp) {
  const response = await fetch(`${SERVER_URL}/v1/streaming.start`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Api-Key": apiKey,
    },
    body: JSON.stringify({ session_id, sdp }),
  });
  if (response.status === 500) {
    console.error("Server error");
    //   updateStatus(
    //     statusElement,
    //     'Server Error. Please ask the staff if the service has been turned on',
    //   );
    throw new Error("Server error");
  } else {
    const data = await response.json();
    return data.data;
  }
}

async function handleICE(session_id, candidate) {
  const response = await fetch(`${SERVER_URL}/v1/streaming.ice`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Api-Key": apiKey,
    },
    body: JSON.stringify({ session_id, candidate }),
  });
  if (response.status === 500) {
    console.error("Server error");
    //   updateStatus(
    //     statusElement,
    //     'Server Error. Please ask the staff if the service has been turned on',
    //   );
    throw new Error("Server error");
  } else {
    const data = await response.json();
    return data;
  }
}

async function talk(session_id, text) {
  // ... (rest of the talk function)
}

async function repeat(session_id, text) {
  const response = await fetch(`${SERVER_URL}/v1/streaming.task`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Api-Key": apiKey,
    },
    body: JSON.stringify({ session_id, text }),
  });
  if (response.status === 500) {
    console.error("Server error");
    //   updateStatus(
    //     statusElement,
    //     'Server Error. Please ask the staff if the service has been turned on',
    //   );
    throw new Error("Server error");
  } else {
    const data = await response.json();
    return data.data;
  }
}

async function stopSession(session_id) {
  const response = await fetch(`${SERVER_URL}/v1/streaming.stop`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Api-Key": apiKey,
    },
    body: JSON.stringify({ session_id }),
  });
  if (response.status === 500) {
    console.error("Server error");
    //updateStatus(statusElement, 'Server Error. Please ask the staff for help');
    throw new Error("Server error");
  } else {
    const data = await response.json();
    return data.data;
  }
}

async function startGenerate(avatar, voice, text) {
  const response = await fetch(`${SERVER_URL}/v2/video/generate`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Api-Key": apiKey,
    },
    body: JSON.stringify({
      video_inputs: [
        {
          character: {
            type: "avatar",
            avatar_id: avatar,
            avatar_style: "normal",
          },
          voice: {
            type: "text",
            input_text: text,
            voice_id: voice,
            speed: 1.1,
          },
        },
      ],
      test: true,
      aspect_ratio: "16:9",
    }),
  });
  if (response.status === 500) {
    console.error("Server error");
    //updateStatus(statusElement, 'Server Error. Please ask the staff for help');
    throw new Error("Server error");
  } else {
    const data = await response.json();
    return data.data;
  }
}

async function generateStatus(videoId) {
  const response = await fetch(
    `https://api.heygen.com/v1/video_status.get?video_id=${videoId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": apiKey,
      },
    }
  );
  if (response.status === 500) {
    console.error("Server error");
    //updateStatus(statusElement, 'Server Error. Please ask the staff for help');
    throw new Error("Server error");
  } else {
    const data = await response.json();
    return data.data;
  }
}
async function generateAudio(message) {
  const voice = "OkklkvS0yCBnEb4idMZB";
  const response = await fetch(
    `https://api.elevenlabs.io/v1/text-to-speech/${voice}`,
    {
      method: "POST",
      headers: {
        accept: "audio/mpeg",
        "Content-Type": "application/json",
        "xi-api-key": process.env.REACT_APP_ELEVEN_API_KEY,
      },
      body: JSON.stringify({
        text: message,
        model_id: "eleven_turbo_v2",
        // voice_settings: {
        //   stability: stability,
        //   similarity_boost: clarity,
        //   style: styleExaggeration,
        //   use_speaker_boost: isSpeakerBoost,
        // },
      }),
    }
  );
  if (response.status === 500) {
    console.error("Server error");
    //updateStatus(statusElement, 'Server Error. Please ask the staff for help');
    throw new Error("Server error");
  } else {
    //const data = await response.json();
    const arrayBuffer = await response.arrayBuffer();
    const blob = new Blob([arrayBuffer], { type: "audio/mp3" });
    const url = URL.createObjectURL(blob)
    console.log("test data",arrayBuffer, url);
    return url;
  }
}

export {
  apiKey,
  SERVER_URL,
  newSession,
  startSession,
  handleICE,
  talk,
  repeat,
  stopSession,
  startGenerate,
  generateStatus,
  generateAudio,
};
